import(/* webpackMode: "eager" */ "/workspace/src/app/layout.tsx");
